import React from 'react';

import { Container } from './styles';

const LinkButton = ({ text, slug, margin }) => {
  return (
    <Container to={slug} margin={margin}>
      {text}
    </Container>
  );
};

export default LinkButton;
